import type { ConfirmationRequest } from './types';

type Listener = (request: ConfirmationRequest | null) => void;

let counter = 0;
let current: ConfirmationRequest | null = null;
const pending: ConfirmationRequest[] = [];
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener(current));
}

export function generateId(): string {
  counter += 1;
  return `confirm-${counter}`;
}

export function showConfirmation(request: ConfirmationRequest): void {
  if (current !== null) {
    pending.push(request);
    return;
  }
  current = request;
  emit();
}

export function resolveConfirmation(result: string | false): void {
  if (current === null) return;
  current.resolve(result);
  current = null;

  if (pending.length > 0) {
    current = pending.shift()!;
  }
  emit();
}

export function getSnapshot(): ConfirmationRequest | null {
  return current;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
